const ar = {
  nav: {
    home:"الرئيسية", about:"الملف المؤسسي", services:"خدماتنا",
    projects:"المشاريع", partners:"الشركاء", downloads:"الموارد", contact:"المناقصات",
  },
  hero: {
    badge:"تميز هندسي معتمد منذ 1992",
    title1:"نحول المشاكل المعقدة", title2:"إلى", titleAccent:"حلول موثوقة",
    sub:"أنظمة هندسية متكاملة في مجال الإطفاء وأنظمة الكهرباء والبنية التحتية — مصممة وفق أعلى المعايير الدولية.",
    cta1:"تقديم عرض سعر", cta2:"استكشف خدماتنا",
  },
  about: {
    label:"// الملف المؤسسي",
    title1:"هندسة السلامة.", title2:"بناء الثقة المؤسسية.",
    body:"تأسست إنتيجريتد سولوشنز عام 1992 لتكون الكيان الهندسي المتعدد التخصصات الأعلى في مصر. نغطي دورة حياة المشروع بالكامل — من التصميم الهندسي الدقيق وإدارة سلسلة التوريد إلى التركيب والتشغيل والدعم الفني على مدار الساعة.",
    vision:"رؤيتنا",
    visionText:"أن نكون المرجع الأول في سلامة المنشآت الصناعية والمؤسسية في مصر والمنطقة.",
    mission:"مهمتنا",
    missionText:"تطبيق معايير السلامة الدولية عبر كوادر هندسية مؤهلة ومكونات تقنية معتمدة عالمياً.",
  },
  stats:{ projects:"مشروع مكتمل", partners:"شريك استراتيجي", years:"عام خبرة", support:"دعم فني" },
  services: {
    label:"// مصفوفة الخدمات الهندسية",
    title:"حلول هندسية متخصصة عالمية المستوى",
    tabs:["إطفاء الحرائق","إنذار الحرائق","جهد منخفض","جهد متوسط","البنية التحتية","أنظمة المضخات"],
    panels:[
      { title:"أ. منظومة أنظمة الإطفاء الكاملة",
        desc:"ندير بيئات احتواء ديناميكية للسوائل تلبي متطلبات NFPA 20، وتركيب تصميمات حماية متطورة للحد من مخاطر الحريق في المستودعات والمنشآت الصناعية المعقدة.",
        features:["شبكة مضخات حريق معتمدة UL/FM","خطوط رشاشات رطبة/جافة أوتوماتيكية","إخماد بالرغوة وتحتوي كيماويات الخطر","خزائن حريق فولاذية وكتل صمامات فاخرة"],
        brands:["بريتغارد","أمريكان هامر","لوبي","تايتانز"],
        standards:["NFPA 13","NFPA 20","UL Listed","FM Approved"],
        imgLabel:"أصول متوافقة مع NFPA", imgSub:"أنابيب متينة وصمامات تحكم مخصصة وتركيبات طوفان كيميائي.",
        img:"https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&q=80&w=800" },
      { title:"ب. شبكات إنذار الحريق الذكية للإنذار المبكر",
        desc:"نشر حلقات قيادة شبكة قابلة للعنونة مدفوعة بالمعالج الدقيق. صفيف تتبع حسي في الوقت الفعلي يضمن تنبيهات سلامة الأصول المحلية السريعة.",
        features:["لوحات قيادة قابلة للعنونة ذكية","أجهزة استشعار دخان بالليزر عالية الحساسية","أنظمة إخلاء صوتي متكاملة","حلول إعادة التجهيز التقليدية"],
        brands:["سيمبلكس","أبولو","هانيويل","ارام تك"],
        standards:["NFPA 72","UL Listed","EN 54","FM Approved"],
        imgLabel:"قيادة الحلقات الذكية", imgSub:"مقاييس تكامل أجهزة معتمدة من ماركات سيمبلكس وأبولو وهانيويل.",
        img:"https://images.unsplash.com/photo-1555664424-778a1e5e1b48?auto=format&fit=crop&q=80&w=800" },
      { title:"ج. لوحات التوزيع الجهد المنخفض وهندسة التحكم",
        desc:"هندسة تخطيط توزيع الطاقة الصناعية. نصمم ونبني وحدات MDB وSMDB المعتمدة ووحدات الأتمتة الذكية التي تحمي منحنيات الاستمرارية.",
        features:["لوحات التوزيع الرئيسية (MDB / SMDB)","مفاتيح التحويل الأوتوماتيكي (ATS Panels)","بنوك المكثفات وأنظمة معامل القدرة","أنظمة التأريض والحماية من الصواعق"],
        brands:["شنايدر إليكتريك","سيمنز","ميريكو","ABB"],
        standards:["IEC 61439","BS 7671","الكود الكهربائي المصري"],
        imgLabel:"تفاعل توجيه الطاقة", imgSub:"ملامح نشر مكونات شنايدر إليكتريك وسيمنز.",
        img:"https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&q=80&w=800" },
      { title:"د. مكونات الشبكة الكهربائية متوسطة الجهد",
        desc:"شبكات توزيع المرافق متوسطة الجهد المتينة المصممة للتشغيل المستمر تحت أحمال صناعية ثقيلة متعددة الميغاواط.",
        features:["نشر وحدات حلقة رئيسية (RMU)","محولات الخفض والرفع الكهربائية","معدات تبديل MV ولوحات التوزيع"],
        brands:["ABB","شنايدر","سيمنز","إيتون"],
        standards:["IEC 62271","IEEE C37","قواعد المرافق المحلية"],
        imgLabel:"نشر الشبكات الثقيلة", imgSub:"مبني وفقاً للوائح المرافق المحلية الصارمة ومعايير IEC.",
        img:"https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&q=80&w=800" },
      { title:"هـ. شبكات البنية التحتية الصناعية الثقيلة",
        desc:"تصميمات المرافق الهيكلية المدنية والكهربائية تحت الأرض التي تتتبع قنوات نقل الطاقة والسوائل عالية الطاقة.",
        features:["صفيف شبكة الشبكة الصناعية","ممرات توجيه الطاقة عالية الطاقة","أنابيب بلدية متكاملة تحت الأرض"],
        brands:["كابيتال بلاس","العطار","إيجي إنجنيرنج"],
        standards:["ISO 9001","كود البناء المصري","OHSAS 18001"],
        imgLabel:"الحلول البلدية", imgSub:"مصفوفات توجيه من البداية إلى النهاية مبنية للمتانة طويلة الأمد.",
        img:"https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&q=80&w=800" },
      { title:"و. ديناميكيات السوائل ومحطات الضخ عالية الطاقة",
        desc:"تهيئة مجموعات مضخات طرد مركزي تعمل بالديزل والكهرباء مرتبطة بمحولات تردد ذات سرعة متغيرة أوتوماتيكية لاستقرار الحلقة المطلق.",
        features:["مضخات ثقيلة مقترنة بمحرك ديزل","استقرار حلقة نظام جوكي الأوتوماتيكي","شبكات معززة للسوائل الصناعية"],
        brands:["لوبي","غروندفوس","إيبارا","KSB"],
        standards:["NFPA 20","UL 448","FM Approved","ISO 9908"],
        imgLabel:"ضوابط نظام السوائل", imgSub:"شريك تنفيذ معتمد مع أبرز ماركات السوائل الدولية.",
        img:"https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80&w=800" },
    ],
  },
  projects: {
    label:"// محفظة المشاريع المنجزة", title:"أحدث المشاريع المنفذة",
    filters:{ all:"الكل", industrial:"صناعي", commercial:"تجاري", infrastructure:"بنية تحتية", healthcare:"صحي" },
    viewDetails:"عرض التفاصيل",
  },
  partners: {
    label:"// مصفوفة سلسلة التوريد الاستراتيجية", title:"الشركاء الهندسيون الرسميون",
    sub:"إنتيجريتد سولوشنز وكيل معتمد وشريك تركيب رسمي لأبرز العلامات التجارية العالمية في أنظمة الإطفاء والكهرباء والسوائل.",
    viewPartner:"الملف الكامل →",
    products:"المنتجات", certificates:"الشهادات", applications:"التطبيقات", about:"نبذة",
    downloadCatalog:"تحميل الكتالوج",
    trustedBy:"موثوق به من المؤسسات الرائدة",
  },
  whychoose: {
    label:"// معايير لا تهاون فيها",
    title:"مصمم وفق أعلى المعايير الدولية",
    body:"كل تصميم تركيب تُنجزه إنتيجريتد سولوشنز يتوافق تماماً مع شهادات السلامة العالمية. نقدم ضمانات هندسية بملايين الدولارات للأصول الحيوية في القطاعين العام والخاص.",
    cta:"جدولة زيارة تدقيق ميداني",
    features:{
      legacy:{    title:"إرث منذ 1992",             desc:"أكثر من ثلاثة عقود من التسليم التقني المتقن عبر أثقل الممرات الصناعية في مصر."},
      compliance:{ title:"مصفوفة حلول UL/FM",       desc:"نزاهة المنتج المطلقة من خلال مسارات الشراء العالمية المعتمدة بالمعايير."},
      engineers:{ title:"مهندسون استشاريون نخبة",   desc:"مجموعات هندسية داخلية متخصصة في الحسابات الهيكلية ومنحنيات ديناميكيات السوائل."},
      support:{   title:"مكتب العمليات 24/7",        desc:"إرسال هندسة طوارئ الحوادث الفورية وتوافر مراقبة المنشأة الحية."},
    },
  },
  downloads: {
    label:"// مكتبة الموارد التقنية", title:"مركز التحميلات",
    sub:"احصل على الكتالوجات الرسمية وصحائف البيانات وشهادات الامتثال والمواصفات الفنية لجميع الأنظمة الهندسية.",
    filters:{ all:"الكل", catalog:"كتالوجات", datasheet:"صحائف بيانات", certificate:"شهادات", standard:"معايير" },
    download:"تحميل PDF", size:"الحجم",
  },
  contact: {
    label:"// مركز الاتصالات", title:"تقديم المناقصات",
    sub:"أرسل وثائق مشروعك التقنية أو طلب العرض التجاري مباشرةً إلى مكتب المقدرين لدينا أو تفضل بزيارة مكاتبنا في مصر.",
    hq:"المقر الرئيسي", ops:"الإدارة والعمليات",
    desk1:"هاتف 1", desk2:"هاتف 2", landline:"الخط الأرضي",
    fields:{ name:"الممثل التجاري", email:"البريد الإلكتروني للشركة", phone:"هاتف التواصل المباشر", scope:"نطاق التخصص", message:"ملخص النطاق التقني" },
    placeholders:{ name:"مثال: م. مصطفى علي", email:"مثال: projects@enterprise.com", phone:"مثال: +20 100000000", message:"اذكر باختصار نطاق المشروع والموقع والمتطلبات التقنية..." },
    scopeOptions:["أنظمة الإطفاء ونشر خط المضخات","توجيه الإنذار الذكي وحلقات الكشف","تصنيع لوحات الجهد المنخفض (MDB/ATS)","مكونات البنية التحتية للجهد المتوسط","تدقيق مشروع MEP الشامل"],
    submit:"إرسال طلب المناقصة", success:"تم تقديم المناقصة بنجاح", successSub:"سيتواصل معك فريق المقدرين خلال 24 ساعة.",
  },
  footer: {
    tagline:"الكيان الهندسي المتعدد التخصصات الأعلى في مصر منذ 1992.",
    services:"الخدمات", company:"الشركة", resources:"الموارد",
    serviceLinks:["إطفاء الحرائق","إنذار الحرائق","جهد منخفض","جهد متوسط","البنية التحتية","أنظمة المضخات"],
    links:{ about:"الملف المؤسسي", projects:"محفظة المشاريع", partners:"الشركاء الاستراتيجيون", downloads:"مركز التحميلات", contact:"تقديم المناقصات" },
    rights:"جميع الحقوق محفوظة.",
  },
  whatsapp:{ tooltip:"تحدث مع مهندس", label:"تحتاج عرض سعر؟" },
};
export default ar;
